import {
  transformQualification,
  transformQualificationForServer,
} from './qualification'

export const transformCustomScope = (customScope) => {
  return {
    id: customScope.id,
    name: customScope.name,
    enabled: customScope.enabled,
    description: customScope.description,
    createdTime: customScope.createdTime,
    canEdit: customScope.updatebleOob,
    canDelete: customScope.deleteableOob,
    viewAccessQualification: transformQualification(
      customScope.viewAccessQualification || { groups: [], operators: [] }
    ),
    viewAccessType: customScope.viewAccessType,
    updateAccessQualification: transformQualification(
      customScope.updateAccessQualification || { groups: [], operators: [] }
    ),
    updateAccessType: customScope.updateAccessType,
    moduleName: customScope.refModel,
  }
}

export const transformCustomScopeForServer = (data) => {
  return {
    description: data.description,
    name: data.name,
    viewAccessType: data.viewAccessType,
    updateAccessType: data.updateAccessType,
    enabled: data.enabled ?? true,
    ...(data.viewAccessQualification &&
    data.viewAccessQualification.groups.length
      ? {
          viewAccessQualification: transformQualificationForServer(
            data.viewAccessQualification
          ),
        }
      : {
          viewAccessQualification: null,
        }),
    ...(data.updateAccessQualification &&
    data.updateAccessQualification.groups.length
      ? {
          updateAccessQualification: transformQualificationForServer(
            data.updateAccessQualification
          ),
        }
      : {
          updateAccessQualification: null,
        }),
  }
}
